import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Investment from './Investment';

export default function Header({ data, compact, isNpo }) {
  const { accountName, logo, report } = data;

  return (<>
    <Row>
      <Col>
        <Link to="/">
          <LogoComponent src={logo} />
        </Link>
        <div>
          <AccountName>{accountName}</AccountName>
          <Location>{report?.program_name || '(no program)'} {report?.year}</Location>
          <Location>{report?.location}</Location>
          {report?.program_manager && (
            <Location>{arrayRotate(report?.program_manager?.split(' '))?.join(' ')}, Program Manager</Location>
          )}
        </div>
      </Col>
    </Row>
    <Row noPadding={compact}>
      <Investment {...{ data, compact, isNpo }} />
    </Row>
  </>);
}

const Col = styled.div`
  display: flex;
`;

const Row = styled.div`
  flex: 1;
  padding: 10px;
  ${({ noPadding }) => !noPadding && 'padding: 10px;'}
`;

const AccountName = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #595959;
`;

const Logo = styled.img`
  margin-right: 20px;
  width: 70px;
  height: 100%;
  max-height: 100px;
`;

const Location = styled.div`
  color: #595959;
  font-size: 18px;
  line-height: 28px;
`;

const LogoComponent = ({ src }) => {
  const [logoSrc, setLogoSrc] = useState(src);
  const handleLogoError = () => {
    setLogoSrc('/images/logo-icon.png');
  };
  return <Logo src={logoSrc} onError={handleLogoError} />;
};

function arrayRotate(arr, reverse) {
  if (!arr) {
    return arr;
  }

  if (reverse) arr.unshift(arr.pop());
  else arr.push(arr.shift());
  return arr;
}
